import React, { useEffect } from "react";
import { AWS_URL } from "./config/constants";

/**
 * Loader component displays a loading spinner/logo
 * @param {Object} props
 * @param {boolean} props.stories - Whether this is a story loader (compact mode)
 * @param {string} props.flag - Optional flag (currently unused but kept for backward compatibility)
 */
const Loader = ({ stories = false }) => {
  useEffect(() => {
    document.body.classList.add("prevent-swipedown");
    return () => {
      document.body.classList.remove("prevent-swipedown");
    };
  }, []);

  const loaderImage = (
    <div className="loader-image">
      <img
        width={100}
        alt="loader"
        src={`${AWS_URL}logo/logoRedCircle.png`}
      />
    </div>
  );

  // Compact loader for stories
  if (stories) {
    return <div className="loader">{loaderImage}</div>;
  }

  // Full-screen overlay loader
  return (
    <div className="loader2">
      <div className="loader-overlay z9999999">
        <div>{loaderImage}</div>
      </div>
    </div>
  );
};

export default Loader;
